require('./cardPinResetStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class CardPinResetStep1 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { clientName, cardType, cardNumber } = this.props;
        const title = formatText('cardPinReset-step1Title');

        return (
            <div className="pin-reset-step1">
                <h4 className="wizard-step--vertical__title">
                    {title}
                </h4>
                <BlockInfo extraClass="pin-reset-step1__information">
                    <p>
                        <FormattedText
                            value="cardPinReset-step1Description"
                            injectedStrings={[cardType, cardNumber]}
                        />
                    </p>

                    <p>
                        <FormattedText
                            value="cardPinReset-step1Confirmation"
                            injectedStrings={[clientName]}
                        />
                    </p>
                </BlockInfo>
            </div>
        );
    }
}

CardPinResetStep1.propTypes = {
    clientName: PropTypes.string.isRequired,
    cardType: PropTypes.string.isRequired,
    cardNumber: PropTypes.string.isRequired
}

module.exports = CardPinResetStep1;
